"use client";
import { useGetMemberFraction } from "@/components/parts/admin/member/api";
import FractionCard from "@/components/sections/landing/fractionCard";
import HeaderPage from "@/components/sections/landing/headerPage";
import { BreadcrumbSetItem } from "@/components/shared/layouts/myBreadcrumb";
import { useParams } from "next/navigation";
import React from "react";

const FractionPage = () => {
  const { slug } = useParams();
  const { data: Fraction } = useGetMemberFraction(slug as string);
  const fractionData = Fraction?.data;
  return (
    <section>
      <BreadcrumbSetItem
        items={[
          {
            title: "Beranda",
            href: `/`,
          },
          {
            title: `Daftar Partai`,
          },
        ]}
      />
      <HeaderPage>PARTAI</HeaderPage>
      <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 my-12">
        {fractionData?.map((item, index) => (
          <FractionCard
            key={index}
            name={item.name}
            logo={item.logo}
            slug={item.slug}
            id={item.id}
          />
        ))}
      </div>
    </section>
  );
};

export default FractionPage;
